import { lazy, Suspense } from "react";

// Defers the TipTap editor (~840KB with prosemirror) into an async chunk —
// it's client-only, so the server renders the null fallback and the editor
// loads after hydration.
const CreateNoteModalImpl = lazy(() => import("./CreateNoteModal.impl"));

const CreateNoteModal = (props) => (
  <Suspense fallback={null}>
    <CreateNoteModalImpl {...props} />
  </Suspense>
);

export default CreateNoteModal;
